export const GET_MESSAGES = 'GET_MESSAGES';

export const GET_ACCORDION = 'GET_ACCORDION';
